
function Footer() {
    return (
        <footer className="footer" id="footer">
            <div className="footer__copyright">
            <p className="footer__copyright-text">&#169; 2021 Around The U.S.</p>
            </div>
        </footer>
    )
}

export default Footer;